/**
 * theme.ts — SINGLE SOURCE OF TRUTH for all visual tokens.
 * Every component MUST import from here. Hardcoded values = rejected.
 */

export const colors = {
  bg: {
    page: 'bg-slate-900',
    card: 'bg-slate-800',
    hover: 'bg-slate-800/50',
    input: 'bg-slate-700',
    overlay: 'bg-slate-900/80',
  },
  accent: {
    primary: 'bg-emerald-500',
    primaryHover: 'bg-emerald-600',
    primaryGhost: 'bg-emerald-500/10',
  },
  text: {
    primary: 'text-white',
    secondary: 'text-slate-400',
    accent: 'text-emerald-400',
    muted: 'text-slate-500',
    heading: 'text-slate-100',
    body: 'text-slate-200',
  },
  status: {
    success: 'text-emerald-400',
    successBg: 'bg-emerald-500/20',
    warning: 'text-amber-400',
    warningBg: 'bg-amber-500/20',
    error: 'text-rose-400',
    errorBg: 'bg-rose-500/20',
    info: 'text-blue-400',
    infoBg: 'bg-blue-500/20',
  },
  border: {
    default: 'border-slate-700',
    subtle: 'border-slate-800',
    active: 'border-emerald-500',
    error: 'border-rose-500',
    warning: 'border-amber-500',
  },
  credits: {
    healthy: 'text-emerald-400',
    low: 'text-amber-400',
    critical: 'text-rose-400',
  },
} as const;

export const radius = {
  card: 'rounded-md',
  button: 'rounded',
  input: 'rounded',
  badge: 'rounded-full',
} as const;

export const spacing = {
  cardPadding: 'p-4',
  sectionGap: 'space-y-6',
  itemGap: 'space-y-2',
  navGap: 'space-y-1',
} as const;

export const font = {
  family: "font-[-apple-system,BlinkMacSystemFont,'Segoe_UI',Roboto,sans-serif]",
} as const;

export const nav = {
  active: 'bg-emerald-500/10 text-emerald-400 border-l-2 border-emerald-500',
  inactive: 'text-slate-400 hover:text-white hover:bg-slate-800/50',
  groupLabel: 'text-[10px] uppercase tracking-wider text-slate-500 px-2',
} as const;

export const sidebar = {
  width: 'w-52',
  collapsedWidth: 'w-16',
  bg: 'bg-slate-900',
  border: 'border-r border-slate-800',
} as const;

export const topBar = {
  height: 'h-12',
  bg: 'bg-slate-900',
  border: 'border-b border-slate-800',
} as const;

/**
 * Returns the Tailwind text-color class for a credits balance.
 * - green (> 50), yellow (10-50), red (< 10)
 */
export function creditsColor(balance: number): string {
  if (balance > 50) return colors.credits.healthy;
  if (balance >= 10) return colors.credits.low;
  return colors.credits.critical;
}
